import { render, staticRenderFns } from "./UsersCrud.vue?vue&type=template&id=932a12f2&scoped=true&"
import script from "./UsersCrud.vue?vue&type=script&lang=js&"
export * from "./UsersCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932a12f2",
  null
  
)

export default component.exports